import { render, staticRenderFns } from "./OpportunityCp.vue?vue&type=template&id=48afc67a&scoped=true&"
import script from "./OpportunityCp.vue?vue&type=script&lang=js&"
export * from "./OpportunityCp.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityCp.vue?vue&type=style&index=0&id=48afc67a&prod&lang=css&"
import style1 from "./OpportunityCp.vue?vue&type=style&index=1&id=48afc67a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48afc67a",
  null
  
)

export default component.exports